/** The three questions that pick the form (mirrors apps/api/src/tax-forms/validate.ts). */
export interface TaxAnswers {
  usPerson: boolean;
  entity: "individual" | "entity";
  servicesInUs: boolean;
}
export type TaxFormKind = "w9" | "w8ben" | "w8bene";

export function formForAnswers(a: TaxAnswers): TaxFormKind {
  if (a.usPerson) return "w9";
  return a.entity === "individual" ? "w8ben" : "w8bene";
}

export const FORM_LABEL: Record<TaxFormKind, string> = {
  w9: "Form W-9",
  w8ben: "Form W-8BEN",
  w8bene: "Form W-8BEN-E",
};
